<template>
<div class="chapter">
<div class="inner_page">
<div>
<h1 class="chapter-number---IVP" title="Dedication"><span epub:type="pagebreak" id="pagev" title="v"></span></h1>
<p class="firstcenter">For Aaron and Amy,</p>
<p class="firstcenter"><i class="i">through whose eyes I learned to see myself as more than a divine typo.</i></p>
<p class="body"><span epub:type="pagebreak" id="pagevi" title="vi"></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_dedication.vue?0ea4cfdf